import React, { useEffect } from 'react';
import { Row, Col, Typography, Spin, Alert, Space, Drawer } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchContentEntryById } from "../api/contentGroups";
import MarkdownIt from 'markdown-it';
import { MarkdownStyles } from '../utils/markdownUtils';

const { Title, Paragraph } = Typography;

const mdParser = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true
});

const DefinitionContent = ({ entry }) => {
    const renderedDefinition = mdParser.render(entry.definition || '');

    return (
        <div>
            <style>{MarkdownStyles}</style>
            <div className={'flex flex-col'}>
                {!entry.useDrawer && <Title level={3}>{entry.term}</Title>}
                <Paragraph>
                    <div
                        className="markdown-content"
                        dangerouslySetInnerHTML={{ __html: renderedDefinition }}
                    />
                </Paragraph>
            </div>
        </div>
    );

};

const Definition = ({
    contentId,
    useDrawer = false,
    drawerWidth = 500,
    onClose,
    visible = false
}) => {
    const dispatch = useDispatch();

    const entry = useSelector((state) => state.contentGroups.entries[contentId]);
    const status = useSelector((state) => state.contentGroups.status[contentId]);
    const error = useSelector((state) => state.contentGroups.error[contentId]);

    useEffect(() => {
        if (!entry && status !== 'loading') {
            dispatch(fetchContentEntryById(contentId));
        }
    }, [dispatch, contentId, entry, status]);

    const renderContent = () => {
        if (status === 'loading') {
            return <Spin tip="Loading content..." />;
        }

        if (status === 'failed') {
            return <Alert message="Error" description={error || "Failed to load content"} type="error" />;
        }

        if (!entry) {
            return null;
        }

        return <DefinitionContent entry={{ ...entry, useDrawer }} />;
    };

    if (useDrawer) {
        return (
            <Drawer
                title={<Typography.Title level={4}>{entry?.name}</Typography.Title>}
                placement="right"
                width={drawerWidth}
                onClose={onClose}
                open={visible}
            >
                {renderContent()}
            </Drawer>
        );
    }

    return renderContent();
};

export default Definition;